import { ajax } from "../settings/settings";

export const login = ({ username, password, code }, callback) => {
  ajax
    .request({
      url: "/web/rest/cashlogin",
      method: "post",
      headers: { apuid: getApUid(), "Content-Type": "application/json" },
      data: {
        username,
        password,
        code,
        cryptograph,
      },
    })
    .then(function(response) {
      if (callback) {
        callback(response);
      }
      console.log(response);
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    })
    .then(function() {
      // always executed
    });
};

export const checkLogin = (url, callback) => {
  if (!url) {
    url = "/member/checklogin?client=?" + Math.random();
  } else {
    url = "/member/checklogin" + url;
  }
  ajax
    .request({
      url: url,
      method: "post"
    })
    .then(function(response) {
      if (callback) {
        callback(response);
      }
      if (response.data.success) {
        sessionStorage.SessionName = "SessionData";
      }
    })
    .catch(function(error) {
      if (callback) {
        callback(error);
      }
      // handle error
      console.log(error);
    })
    .then(function() {
      // always executed
    });
};

export const checkValidUser = ({ username }, callback) => {
  ajax
    .request({
      url: "/web/rest/check",
      method: "get",
      params: {
        username: username
      }
    })
    .then(function(response) {
      if (callback) {
        callback(response.data);
      } else {
        console.log(response);
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};

export const checkNameAndCode = ({ username, mobile, code }, callback) => {
  ajax
    .request({
      url: "/web/rest/checkNameAndCode",
      method: "get",
      params: {
        username: username,
        mobile: mobile,
        code: code
      }
    })
    .then(function(response) {
      if (response.data.success) {
        sendGetPasswordCode({ username, mobile }, function(response) {
          if (callback) {
            callback(response);
          } else {
            console.log(response);
          }
        });
      } else {
        if (callback) {
          callback(response);
        } else {
          console.log(response);
        }
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};

export const sendGetPasswordCode = ({ username, mobile }, callback) => {
  ajax
    .request({
      url: "/web/rest/sendgetpwdcode",
      method: "get",
      params: {
        type: 0,
        destination: mobile,
        name: username
      }
    })
    .then(function(response) {
      if (callback) {
        callback(response);
      } else {
        console.log(response);
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};

export const setPassword = ({ name, code, password }, callback) => {
  ajax
    .request({
      url: "/web/rest/forgetPassword",
      method: "post",
      headers: { apuid: getApUid(), "Content-Type": "application/json" },
      data: {
        name,
        code,
        password,
      },
    })
    .then(function(response) {
      if (callback) {
        callback(response);
      } else {
        console.log(response);
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};

export const register = (data, callback) => {
  const formData = new FormData();
  Object.keys(data).forEach((key, i) => {
    if (data[key]) formData.set(key, data[key]);
  });

  ajax({
    method: "post",
    url: "/web/rest/reg",
    data: formData
  })
    .then(function(response) {
      if (callback) {
        callback(response);
      } else {
        console.log(response);
      }
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};
